<template>
  <div class="selection-dropdowns-comp">
    <div class="SD-text">
      <p>{{ title }}</p>
    </div>
    <div class="SD-select">
      <select class="select-input" v-model="optionSelect">
        <option value="" selected disabled>Please select an option</option>
        <option
          v-for="(option, index) in options"
          :key="`${$route.name}_selectDrops_${index}`"
          :value="option.value"
        >
          {{ option.value }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectionDropdowns",
  data() {
    return {
      optionSelect: "",
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default() {
        return [
          { value: "value 1" },
          { value: "value 2" },
          { value: "value 3" },
        ];
      },
    },
  },
};
</script>

<style lang="scss">
.selection-dropdowns-comp {
  .SD-select {
    .select-input {
      padding: 10px 5px;
      width: 100%;
      border-radius: 8px;
    }
  }
}
</style>